import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import NickName from "./components/Nickname/Nickname";
import LoaderImg from "./assets/images/Icons/ajax-loader.svg"

import LaunchLobby from "./components/LaunchLobby/LaunchLobby";
import { withTranslation } from "react-i18next";
import LogoutMesage from "./components/Common/LogoutMesage.js";
import NotAvailable from "./components/Common/NotAvailable.js";


import hkbLogo from './assets/images/Logo/logo.png'

import { useDispatch } from "react-redux";
// import wifiIcon from "./assets/images/Icons/icons/wifi_icon.svg";
// import closeIcon from "./assets/images/Icons/icons/close_icon.svg";
import wifiIcon from "./assets/images/Icons/icons/wifiIconDark.png";
import closeIcon from "./assets/images/Icons/icons/closeDark.png";
import wifiLight from "./assets/images/Icons/icons/wifiIcon_light.png";
import closeLight from "./assets/images/Icons/icons/close_light.png"
import SnowFall from "./components/FestiveTheme/SnowFall.js";
// import { setCommonConfig } from "./redux/actions.js";
import { useSelector } from "react-redux";
import { setCommonConfig } from "./redux/actions.js";
import ServerError from "./components/Common/ServerError.js";
import Maintenance from "./components/Maintenance/Maintenance.js";
import { makeAjax, url } from "./helpers/global_helper.js";
import PlayerBlockPopup from "./components/LobbyContent/SubComponents/PlayerBlockPopup.js";
import Bonus from "./components/Bonus.js";
import { BrowserRouter as Router } from "react-router-dom";

function App() {

  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState('');
  const clientLoader = loader;
  const loginToken = localStorage.getItem("token")
  const [loginHeader, setLoginHeader] = useState(false)
  const [partnerKey, setPartnerKey] = useState('');
  const device = useSelector(state => state.CommonConfig.device_type);
  const [loadingComp, setLoadingComp] = useState(true)
  const [width, setWidth] = useState(0);
  const [showBonus, setShowBonus] = useState(false);
  const partnerName = partnerKey || localStorage.getItem("partner");
  const FestiveTheme = 0;
  const [isNewUser, setIsNewUser] = useState(true);
  // const device = useSelector(state => state.CommonConfig.device_type);
  const currentStep = useSelector((state) => state.paginationData.currentStep);
  const theme = localStorage.getItem("theme");



  const fetchImgData = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.text();
      // Loader Image
      const base64Regex1 = /loading_lobby\s*=\s*"([^"]*)"/;
      const match1 = data.match(base64Regex1);
      if (match1 && match1.length > 1) {
        setLoader(match1[1]);
      } else {
        // console.error('404 Loader Image not found');
      }
      // Logo Image
      // const base64Regex2 = /logo\s*=\s*"([^"]*)"/;
      // const match2 = data.match(base64Regex2);
      // if (match2 && match2.length > 1) {
      //   setLogo(match2[1]);
      // } else {
      //   // console.error('404 Logo Image not found');
      // }
    } catch (error) {
      // console.error('Error fetching the JS file:', error);
    }
  };


  const fetchFtpLogo = async () => {

    const response = await makeAjax(url.PLAYER_API.fetchLoader, [], url.PLAYER_MS_EXT);
    if (response) {
      await fetchImgData(response.data.loaderJS);

    }

  }

  useEffect(() => {
    if (loginToken) {
    fetchFtpLogo();
    }
  }, [loginToken])

  useEffect(() => {
    const handlePartnerNameChange = () => {
      setPartnerKey(localStorage.getItem("partner"));
    };
    window.addEventListener("partnerNameChange", handlePartnerNameChange);
    return () => {
      window.removeEventListener("partnerNameChange", handlePartnerNameChange);
    };
  }, []);

  const helpRunfunction = () => {
    makeAjax(url.PLAYER_API.checkSession, {}, url.PLAYER_MS_EXT)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      helpRunfunction()
    }, 120000);
    return () => clearInterval(interval);
  }, [])


  useEffect(() => {
    let interval;
    if (isLoading) {
      setWidth(0); // Reset width to 0 when loading starts
      interval = setInterval(() => {
        setWidth((prevWidth) => {
          const newWidth = prevWidth + 1;
          if (newWidth >= 100) {
            clearInterval(interval);
          }
          return newWidth;
        });
      }, 65);
    } else {
      setTimeout(() => {

        setWidth(100);

      }, 500);
    }
    return () => clearInterval(interval);
  }, [isLoading]);

  useEffect(() => {
    if (
      !isLoading &&
      window.location.pathname !== "/logout" &&
      window.location.pathname !== "/sessionexpirelogout" &&
      window.location.pathname !== "/nickname" &&
      window.location.pathname !== "/maintenance"
    ) {
      const timer = setTimeout(() => {
        setShowBonus(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading, window.location.pathname]);

  useEffect(() => {
    if (loginHeader) {
      setTimeout(() => {
        setIsLoading(false)
      }, 500);
    }
  }, [loginHeader])

  useEffect(() => {
    if (window.location.pathname == "/logout") {
      setIsLoading(false)
    }
    if (window.location.pathname == "/no-games") {
      setIsLoading(false)
    }
    if (window.location.pathname == "/blockUser") {
      setIsLoading(false)
    }
    if (window.location.pathname == "/nickname") {
      // setTimeout(() => {
      setIsLoading(false)
      // }, 2500);
    }

  }, [window.location.pathname, loginToken])


  const closeOnlinePopup = () => {
    setIsOnline(false)
  }

  useEffect(() => {
    if (!isLoading && width === 100) {
      setTimeout(() => {

        setLoadingComp(false)
      }, 500);
    }
  }, [width, isLoading])

  useEffect(() => {
    function isDevice() {
      const userAgent = navigator.userAgent;
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
      const isTablet = /iPad|Android/.test(userAgent) && !isMobile;

      if (isMobile) {
        return "Mobile";
      } else if (isTablet) {
        return "Tablet";
      } else {
        return "Desktop";
      }
    }
    window.isDevice = isDevice;
    const device = window.isDevice();
    dispatch(setCommonConfig({ key: "device_type", value: device }));
    return () => {
      delete window.isDevice;
    };
  }, [dispatch]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [device]);


  const onClose = () => {
    document.getElementById("commonToaster").style.display = "none";
  };

  return (
    <>
      {
        FestiveTheme === 1 && <SnowFall />
      }
      <div id="commonToaster" className="error-popup" >
        <div className="error-popup-content">
          <span className="close" onClick={onClose}>
            &times;
          </span>
          <p id="commonToasterHeading" className="message"></p>
          <p id="commonToasterBody" className="error-message"></p>
        </div>
      </div>

      {!loadingComp && (
        <div className="ajax_loader_container hideMe" id="ajax-loader">
          <div className="ajax_loader">
            <img src={LoaderImg} alt="" />
          </div>
        </div>
      )}

      {loadingComp && window.location.pathname !== "/logout" && (
        <div className="loader-background">
          <div id="ajax-loader" className="custom-loader">
            <div className="custom-loader-line" style={{ width: `${width}%` }}></div>
            <div className="lds-ripple"></div>
          </div>
        </div>
      )}

      {loadingComp && window.location.pathname !== "/logout" && (
        <div className="loader-background">
          <div className="loader_img">
            <svg width="100%" height="auto">
              {clientLoader && <image xlinkHref={clientLoader === "h" ? hkbLogo : clientLoader} width="100%" height="100%"></image>}
            </svg>
          </div>
          <div id="ajax-loader" className="custom-loader">
            <div className="custom-loader-line" style={{ width: `${width}%` }}></div>
            {clientLoader !== '' && (
              <div className="lds-ripple"></div>
            )}
          </div>
          {/* {partnerName && partnerName !== null &&
            !partnerName.toLowerCase().includes('nagaemas') && (
              // <div className="loader-footer">
              //   Copyright © 2016 {partnerName.toUpperCase()}. All Rights Reserved.
              // </div>
              <div className="loader-footer">
                Copyright © {localStorage.getItem('partnerYear')}{" "}
                {partnerName && partnerName.toLowerCase() !== "crazyrich88"
                  ? partnerName.toUpperCase() + ". "
                  : ""}
                All Rights Reserved.
              </div>
            )} */}
          {(localStorage.getItem('partnerFlag') == 1) &&
            <div className="loader-footer">
              Copyright © {localStorage.getItem('partnerYear')}{" "}
              {partnerName.toUpperCase()}. All Rights Reserved.
            </div>
          }
        </div>
      )}

      {!isOnline && (
        <>
          <div className="notification_sub_popup_overlay" ></div>
          <div className="notification_sub_popup">
            <div className="notification_Details conn_lost_detail">
              <button onClick={closeOnlinePopup} className="btnclose">

                {theme == 0 ? (
                  <div className="connect-wifi">
                    <img src={closeLight} alt="Light Theme Image" />
                  </div>
                ) : (
                  <div className="connect-wifi">
                    <img src={closeIcon} alt="Dark Theme Image" />
                  </div>
                )}

              </button>
              <div className="conn_lost_inner">
                {theme == 0 ? (
                  <div className="connect-wifi">
                    <img src={wifiLight} alt="Light Theme Image" />
                  </div>
                ) : (
                  <div className="connect-wifi">
                    <img src={wifiIcon} alt="Dark Theme Image" />
                  </div>
                )}
                <h2></h2>
                <div className="notification_body">
                  <h3>
                    Connection Lost
                  </h3>
                  <p>Your connection appears to be off-line.</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showBonus && <Bonus />}
      {currentStep === 1 && <div className="dimmed-overlay"></div>}
      <div id={`${(device === "Mobile" || device === "Tablet") ? "mobile" : "desktop"}`} className={`${FestiveTheme === 1 ? "festiveTheme" : ""}${FestiveTheme === 2 ? "chineseTheme" : FestiveTheme === 3 ? "ramadanTheme" : ""}`}>
        <Router>
          <Routes>
            <Route path="/api/lobby/:token/:operatorid/:username/:game_id?" element={<LaunchLobby setLoader={setLoader} setPartnerKey={setPartnerKey} />} />
            <Route path="/logout" element={<LogoutMesage />} />
            <Route path="*" element={<HomePage setLoginHeader={setLoginHeader} />} />
            <Route path="/homepage" element={<HomePage setLoginHeader={setLoginHeader} />} />
            <Route path="/nickname" element={<NickName />} />
            <Route path="/app/:error_type" element={<ServerError />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/blockUser" element={<PlayerBlockPopup />} />
            <Route path="/no-games" element={<NotAvailable />} />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default withTranslation()(App);
